<p-toast></p-toast>
<div class="formulario">
    <app-formulario [url_imagenes_bottom]="url_imagen_bottom" [url_imagen_cabecera]="url_imagenes" [formulario]="formulario" (enviarFormulario)="onRecibirFormulario($event)"></app-formulario>
</div>
<p-dialog [(visible)]="ver_dialog_sms" [modal]="true" [draggable]="false" [closable]="false">
    <app-formulario [formulario]="formulario_codigo_sms" (enviarFormulario)="onRecibirFormularioSMS($event)"></app-formulario>
</p-dialog>

<p-dialog [(visible)]="ver_dialog_distribuidor_no_encontrado" [modal]="true" [draggable]="false" [closable]="false">
    <div style="text-align: center; font-family: 'Arial', sans-serif; font-size: 1.5em; color: black;">
        <p style="margin: 0; font-weight: bold;">
            El distribuidor no se encuentra registrado, por favor,
        </p>
        <p style="margin: 0; font-weight: bold;">
            introduzca un distribuidor válido en la URL.
        </p>
    </div>
</p-dialog>



